import request from 'api/request';

export default function confirmEmailRoute({ email, token }) {
  return request({
    url: '/emails/confirm',
    method: 'PUT',
    data: { email, token },
  });
}
